// Process component
import ProcessIndex from "@/components/processEditor/index.vue";
import ProcessGate from "@/components/processEditor/Gateway.vue";
import ProcessEditor from "@/components/processEditor/Editor.vue";

// 프로세스 관련 Path
const ProcessRoute = {
  path: "/process",
  component: ProcessIndex,
  meta: { requireAuth: true },
  children: [
    {
      path:'/process/gate',
      name:'ProcessGateway',
      component: ProcessGate
    },
    {
      path:'/process/editor',
      name:'ProcessEditor',
      component: ProcessEditor
    },
  ]
} ; 

export default ProcessRoute ; 